var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initLineItemCard = /* @__PURE__ */ __name(($el, lineItemKey) => {
  var _a, _b;
  const random_id = utils.shortUUID();
  const cart = Alpine.store("cart");
  const lineItem = Shopify.designMode ? (_a = cart.state.items.find((item) => item.key === lineItemKey)) != null ? _a : cart.state.items[0] : cart.state.items.find((item) => item.key === lineItemKey);
  let product = _products[lineItem == null ? void 0 : lineItem.handle];
  if (!product) {
    _product.getProductData(lineItem == null ? void 0 : lineItem.handle, lineItem == null ? void 0 : lineItem.product_id).then((prod) => {
      var _a2;
      state.product = prod;
      state.variant = (_a2 = prod == null ? void 0 : prod.variants) == null ? void 0 : _a2.find((variant2) => variant2.id === (lineItem == null ? void 0 : lineItem.variant_id));
      state.hydrated = true;
    });
  }
  product != null ? product : product = _products[lineItem == null ? void 0 : lineItem.handle];
  const variant = (_b = product == null ? void 0 : product.variants) == null ? void 0 : _b.find((variant2) => variant2.id === (lineItem == null ? void 0 : lineItem.variant_id));
  const state = window.Alpine.reactive({
    random_id,
    subscriptionIsChanging: false,
    hydrated: !!variant,
    line_item: lineItem,
    product,
    variant,
    url: lineItem == null ? void 0 : lineItem.url
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  const hideIfEmpty = /* @__PURE__ */ __name((element, hide_if_empty, isEmpty = false) => {
    var _a2, _b2;
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        (_a2 = element.closest(`.shopify-section`)) == null ? void 0 : _a2.classList.toggle("!hidden", isEmpty);
        break;
      case "container":
        (_b2 = element.closest(`[data-style-id]:not([data-style-id="${element.getAttribute("data-style-id")}"])`)) == null ? void 0 : _b2.classList.toggle("!hidden", isEmpty);
        break;
      case "block":
        break;
    }
  }, "hideIfEmpty");
  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicText,
    getContentLabels,
    hideIfEmpty
  };
}, "initLineItemCard");
const hydrateLineItemCard = /* @__PURE__ */ __name(($el, card_handle, line_item_key, classes = []) => {
  var _a;
  const node = (_a = document.querySelector(`[data-line-item-card='${card_handle}']`)) == null ? void 0 : _a.cloneNode(true);
  if (!node) {
    $el.setAttribute("data-intersected", "true");
    const mo = new MutationObserver((mutation, obs) => {
      var _a2;
      if ($el.hasAttribute("data-cards-loaded")) {
        $el.removeAttribute("data-intersected");
        const node2 = (_a2 = document.querySelector(`[data-line-item-card='${card_handle}']`)) == null ? void 0 : _a2.cloneNode(true);
        if (node2 && $el && $el.parentNode) {
          node2 == null ? void 0 : node2.removeAttribute(`data-line-item-card`);
          node2 == null ? void 0 : node2.setAttribute("data-line-item-key", line_item_key);
          node2.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
            el.remove();
          });
          node2.classList.add(...classes);
          $el.parentNode.replaceChild(node2, $el);
        }
        mo.disconnect();
      }
    });
    mo.observe($el, { attributes: true });
    return;
  }
  if (node && $el && $el.parentNode) {
    node == null ? void 0 : node.removeAttribute(`data-line-item-card`);
    node == null ? void 0 : node.setAttribute("data-line-item-key", line_item_key);
    node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
      el.remove();
    });
    node.classList.add(...classes);
    $el.parentNode.replaceChild(node, $el);
  }
}, "hydrateLineItemCard");
window._sections["initLineItemCard"] = initLineItemCard;
window._sections["hydrateLineItemCard"] = hydrateLineItemCard;
